require('babel-polyfill')
require('./init')
require('./libs/thinkingdata.umd.min')

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { IS_DEV, TA_APP_ID } from './config'
import { Swipe, SwipeItem, Icon } from 'vant'
import Toast from './components/Toast'

if (IS_DEV) {
  require.ensure([], require => {
    const VConsole = require('vconsole')
    new VConsole()
  }, 'vconsole')
}

import api from './api/api'
Vue.mixin(api)

import store from './store'

import './style/wepie.styl'

Vue.prototype.$ta = window.thinkingdata
thinkingdata.init({
  appId: TA_APP_ID,
  serverUrl: '//think.afunapp.com'
})
Vue.config.productionTip = false
Vue.prototype.$toast = Toast
Vue.prototype.$loadWxScript = function () {
  const ele = document.querySelector('#wx-script')
  if (ele) {
    return Promise.resolve()
  }

  return new Promise((resolve) => {
    const scriptTag = document.createElement('script')
    scriptTag.id = 'wx-script'
    scriptTag.src = '//res2.wx.qq.com/open/js/jweixin-1.6.0.js'
    scriptTag.onload = resolve
    document.body.appendChild(scriptTag)
  })
}
Vue.config.errorHandler = function (err, vm, info) {
  // eslint-disable-next-line no-console
  console.error(err, vm, info)
}

Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Icon)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
